module.exports = __webpack_public_path__ + "img/HWALLMOUNT.4fe1145d.jpg";